import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";
import ProtectedRoute from "./ProtectedRoute";

// Auth
import Login from "../auth/login/login";
import Register from "../auth/register/register";
import ForgotPassword from "../auth/forgot-password/forgotPassword";
import ChangePassword from "../auth/change-password/changePassword";

// Home
import HomeOne from "../home-one/homeOne";

// Flight
import FlightList from "../flight/flight-list/flightList";
import FlightGrid from "../flight/flight-grid/flightGrid";
import FlightDetails from "../flight/flight-details/flightDetails";
import FlightAmenities from "../flight/flight-amenities/flightAmenities";
import FlightBooking from "../flight/flight-booking/flightBooking";
import FlightBookingConfirmation from "../flight/flight-booking-confirmation/flightBookingConfirmation";
import FlightHoldConfirmation from "../flight/flight-hold-confirmation/FlightHoldConfirmation";

// Hotel
import HotelList from "../hotel/hotel-list/hotelList";
import HotelGrid from "../hotel/hotel-grid/hotelGrid";
import HotelMap from "../hotel/hotel-map/hotelMap";
import HotelDetails from "../hotel/hotel-details/hotelDetails";
import HotelGuestDetails from "../hotel/hotel-details/HotelGuestDetails";
import HotelBooking from "../hotel/hotel-booking/hotelBooking";

// User dashboard (protected)
import Dashboard from "../userDashboard/dashboard/dashboard";
import Payment from "../userDashboard/payment/payment";
import Notification from "../userDashboard/notification/notification";
import UserFlightBooking from "../userDashboard/myBooking/flight/userFlightBooking";
import UserHotelsBooking from "../userDashboard/myBooking/hotels/userHotelsBooking";
import UserReviews from "../userDashboard/myReviews/userReviews";
import UserChat from "../userDashboard/message/userChat";
import UserWishlist from "../userDashboard/wishlist/userWishlist";
import UserWallet from "../userDashboard/wallet/userWallet";
import MyProfile from "../userDashboard/myProfile/myProfile";
import ProfileSettings from "../userDashboard/settings/profileSettings";
import SecuritySettings from "../userDashboard/settings/securitySettings";
import NotificationSettings from "../userDashboard/settings/notificationSettings";
import IntegrationSettings from "../userDashboard/settings/integrationSettings";
import Invoices from "../pages/invoices/invoices";

// Static pages
import AboutUs from "../pages/about-us/about_us";
import ContactUs from "../pages/contact/contactUs";
import PrivacyPolicy from "../pages/privacy-policy/privacyPolicy";
import TermsConditions from "../pages/terms-conditions/termsConditions";
import FAQ from "../pages/Faq/FAQ";
import Error404 from "../pages/error/Error404";
import Error500 from "../pages/error/Error500";

// Admin
import AdminDashboard from "../admin/AdminDashboard";

// Bot
import TrioBot from "../../core/common/Bot/TrioBot";

const routes = all_routes;

export const publicRoutes = [
  {
    path: "/",
    name: "Root",
    element: <Navigate to="/index" />,
    route: Route,
  },
  {
    path: routes.home1,
    element: <HomeOne />,
    route: Route,
  },

  // ─── Flight ───
  {
    path: routes.flightList,
    element: <FlightList />,
    route: Route,
  },
  {
    path: routes.flightGrid,
    element: <FlightGrid />,
    route: Route,
  },
  {
    path: routes.flightDetails,
    element: <FlightDetails />,
    route: Route,
  },
  {
    path: routes.flightAmenities,
    element: <FlightAmenities />,
    route: Route,
  },
  {
    path: routes.flightBooking,
    element: <FlightBooking />,
    route: Route,
  },
  {
    path: routes.flightBookingConfirmation,
    element: <FlightBookingConfirmation />,
    route: Route,
  },
  {
    path: routes.flightHoldConfirmation,
    element: <FlightHoldConfirmation />,
    route: Route,
  },

  // ─── Hotel ───
  {
    path: routes.hotelList,
    element: <HotelList />,
    route: Route,
  },
  {
    path: routes.hotelGrid,
    element: <HotelGrid />,
    route: Route,
  },
  {
    path: routes.hotelMap,
    element: <HotelMap />,
    route: Route,
  },
  {
    path: routes.hotelDetails,
    element: <HotelDetails />,
    route: Route,
  },
  {
    path: routes.hotelGuestDetails,
    element: <HotelGuestDetails />,
    route: Route,
  },
  {
    path: routes.hotelBooking,
    element: <HotelBooking />,
    route: Route,
  },

  // ─── Payment ───
  {
    path: routes.payment,
    element: <Payment />,
    route: Route,
  },

  // ─── Static pages ───
  {
    path: routes.about_us,
    element: <AboutUs />,
    route: Route,
  },
  {
    path: routes.contactUs,
    element: <ContactUs />,
    route: Route,
  },
  {
    path: routes.privacyPolicy,
    element: <PrivacyPolicy />,
    route: Route,
  },
  {
    path: routes.termsConditions,
    element: <TermsConditions />,
    route: Route,
  },
  {
    path: routes.FAQ,
    element: <FAQ />,
    route: Route,
  },
  {
    path: routes.invoices,
    element: <Invoices />,
    route: Route,
  },

  // ─── Bot ───
  {
    path: routes.triobot,
    element: <TrioBot />,
    route: Route,
  },

  // ─── Admin (admin role required) ───
  {
    path: routes.admin,
    element: (
      <ProtectedRoute requiredRole="admin" redirectTo="/">
        <AdminDashboard />
      </ProtectedRoute>
    ),
    route: Route,
  },

  // ─── User dashboard (login required) ───
  {
    path: routes.userDashboard,
    element: <ProtectedRoute redirectTo="/"><Dashboard /></ProtectedRoute>,
    route: Route,
  },
  {
    path: routes.userFlightBooking,
    element: <ProtectedRoute redirectTo="/"><UserFlightBooking /></ProtectedRoute>,
    route: Route,
  },
  {
    path: routes.userHotlesBooking,
    element: <ProtectedRoute redirectTo="/"><UserHotelsBooking /></ProtectedRoute>,
    route: Route,
  },
  {
    path: routes.userReviews,
    element: <ProtectedRoute redirectTo="/"><UserReviews /></ProtectedRoute>,
    route: Route,
  },
  {
    path: routes.userChat,
    element: <ProtectedRoute redirectTo="/"><UserChat /></ProtectedRoute>,
    route: Route,
  },
  {
    path: routes.userWishlist,
    element: <ProtectedRoute redirectTo="/"><UserWishlist /></ProtectedRoute>,
    route: Route,
  },
  {
    path: routes.userWallet,
    element: <ProtectedRoute redirectTo="/"><UserWallet /></ProtectedRoute>,
    route: Route,
  },
  {
    path: routes.myProfile,
    element: <ProtectedRoute redirectTo="/"><MyProfile /></ProtectedRoute>,
    route: Route,
  },
  {
    path: routes.profileSettings,
    element: <ProtectedRoute redirectTo="/"><ProfileSettings /></ProtectedRoute>,
    route: Route,
  },
  {
    path: routes.securitySettings,
    element: <ProtectedRoute redirectTo="/"><SecuritySettings /></ProtectedRoute>,
    route: Route,
  },
  {
    path: routes.notificationSettings,
    element: <ProtectedRoute redirectTo="/"><NotificationSettings /></ProtectedRoute>,
    route: Route,
  },
  {
    path: routes.integrationSettings,
    element: <ProtectedRoute redirectTo="/"><IntegrationSettings /></ProtectedRoute>,
    route: Route,
  },
  {
    path: routes.notification,
    element: <ProtectedRoute redirectTo="/"><Notification /></ProtectedRoute>,
    route: Route,
  },
];

export const authRoutes = [
  {
    path: routes.login,
    element: <Login />,
    route: Route,
  },
  {
    path: routes.register,
    element: <Register />,
    route: Route,
  },
  {
    path: routes.forgotPassword,
    element: <ForgotPassword />,
    route: Route,
  },
  {
    path: routes.changepassword,
    element: <ChangePassword />,
    route: Route,
  },
  {
    path: routes.Error404,
    element: <Error404 />,
    route: Route,
  },
  {
    path: routes.Error500,
    element: <Error500 />,
    route: Route,
  },
];
